import i18n from '@/plugins/i18n';
import { rules } from '@/common/validations';

// CSV_PATIENT_FIELDS is function maded to translate text after changing lang.
// To use it in components type CSV_PATIENT_FIELDS()

const CSV_PATIENT_FIELDS = () => ({
  // add-google-cloud-storage-bucket
  // Delete this line after testing
  // clinic: {
  //   name: i18n.t('forms.clinic'),
  //   rules: [
  //     rules.required,
  //   ],
  // },
  username: {
    name: i18n.t('forms.username'),
    rules: [
      rules.required,
      rules.alphaNum,
      (v) => rules.minLen(v, 2),
      (v) => rules.maxLen(v, 30),
    ],
  },
  first_name: {
    name: i18n.t('forms.firstNameLabel'),
    rules: [
      rules.required,
      (v) => rules.minLen(v, 2),
      (v) => rules.maxLen(v, 50),
    ],
  },
  last_name: {
    name: i18n.t('forms.lastNameLabel'),
    rules: [
      rules.required,
      (v) => rules.minLen(v, 2),
      (v) => rules.maxLen(v, 50),
    ],
  },
  email: {
    name: i18n.t('forms.emailLabel'),
    rules: [
      rules.required,
      rules.email,
    ],
  },
  gender: {
    name: i18n.t('forms.genderLabel'),
    rules: [],
  },
  country_code: {
    name: i18n.t('forms.countryCode'),
    rules: [],
  },
  phone_number: {
    name: i18n.t('userDetails.phoneNumber'),
    rules: [rules.phone],
  },
  alt_country_code: {
    name: i18n.t('forms.altCountryCode'),
    rules: [],
  },
  alternate_number: {
    name: i18n.t('forms.alternateNumber'),
    rules: [],
  },
  date_of_birth: {
    name: i18n.t('forms.dateOfBirth'),
    rules: [rules.required],
  },
  fax_country_code: {
    name: i18n.t('forms.faxCountryCode'),
    rules: [],
  },
  fax_number: {
    name: i18n.t('forms.faxNumber'),
    rules: [],
  },
  language_primary: {
    name: i18n.t('forms.languagePrimary'),
    rules: [],
  },
  address: {
    name: i18n.t('forms.street'),
    rules: [],
  },
  country: {
    name: i18n.t('forms.country'),
    rules: [],
  },
  state: {
    name: i18n.t('forms.state'),
    rules: [],
  },
  city: {
    name: i18n.t('forms.city'),
    rules: [],
  },
  zipcode: {
    name: i18n.t('forms.zipCode'),
    rules: [rules.zipCode],
  },
  policy_id: {
    name: i18n.t('forms.policyId'),
    rules: [],
  },
  insurance_company: {
    name: i18n.t('forms.insuranceCompany'),
    rules: [],
  },
  subscriber_relationship: {
    name: i18n.t('userDetails.subscriberRelation'),
    rules: [],
  },
  subgroup_identifier: {
    name: i18n.t('forms.subgroupIdentifier'),
    rules: [],
  },
  sponsor: {
    name: i18n.t('forms.sponsor'),
    rules: [],
  },
  activation_date: {
    name: i18n.t('forms.activationDate'),
    rules: [],
  },
  termination_date: {
    name: i18n.t('forms.terminationDate'),
    rules: [],
  },
  department: {
    name: i18n.t('constants.department'),
    rules: [],
  },
});

export default CSV_PATIENT_FIELDS;
